import dayjs from 'dayjs'

export const formatPhoneNumber = (phoneNumberString) => {
  if (phoneNumberString) {
    const cleaned = String(phoneNumberString).replace(/\D/g, '')
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      const intlCode = match[1] ? '+1 ' : ''
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
  }
  return ''
}

export const formatTimeAndDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }
  return ''
}

export const formatDate = (dateString) => {
  if (dateString) {
    // Use dayjs so 'YYYY-MM-DD' is parsed as local time (not UTC midnight),
    // which avoids dates rolling back a day in negative-offset timezones.
    return dayjs(dateString).format('MM/DD/YYYY')
  }
  return ''
}

export const formatTime = (dateString) => {
  if (dateString) {
    return dayjs(dateString, 'HH:mm:ss').format('h:mm A')
  }
  return ''
}

export const formatTimeRange = (startTimeString, endTimeString) => {
  if (startTimeString && endTimeString) {
    return `${formatTime(startTimeString)}-${formatTime(endTimeString)}`
  }
  return ''
}

/**
 * Formats a score as a percentage string.
 * @param {number} correct
 * @param {number} total
 * @returns {string}
 */
export const scoreFormatter = (correct, total) => {
  if (Number.isNaN(parseInt(correct, 10)) || Number.isNaN(parseInt(total, 10))) return ''
  if (total === 0) return '0%'
  return `${((correct / total) * 100).toFixed(0)}%`
}
